import React from 'react';
import { Card, CardText } from 'react-toolbox/lib/card';
import TextBlock from '../../../../common/components/TextBlock';

const TextCard = ({ children, style }) => {
  return children ? (
    <Card style={{ alignSelf: 'stretch', ...style }}>
      <CardText>
        <TextBlock>{children}</TextBlock>
      </CardText>
    </Card>
  ) : null;
};

export default TextCard;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Elements/TextCard.js